import Helper from "./Helper";

class Header {
  constructor(config = {}) {
    this.htmlTag = document.getElementsByTagName('html')[0];
    this.menuToggler = document.querySelector('.js-menu-toggle');

    this.subMenuTogglesLvl0 = Array.prototype.slice.call(document.querySelectorAll('.header-navigation .menu__item--has-children > .menu__link.menu__link--level-0'));
    this.subMenuTogglesLvl1 = Array.prototype.slice.call(document.querySelectorAll('.header-navigation .menu__item--has-children > .menu__link.menu__link--level-1'));
    this.menuItemBack = document.querySelectorAll(".menu__item--back");

    this.menuItemHasDownload = document.querySelectorAll(".menu__item--has-download");

    this.menuContainerToggles = document.querySelectorAll(".header-navigation__title");

    this.activeMenuItem = document.querySelector(".menu__item--active");

    this.currentOpenLevel1 = false;
    this.currentOpenLevel2 = false;
    this.activeMenuItem = document.querySelector(".menu__item--active");
    
    
    this.setUp();
    this.bindEvents();
  }

  setUp() {
    if (this.activeMenuItem) {
      this.activeMenuItem.closest('.menu__item--level-0').classList.remove('submenu-open');
      this.activeMenuItem.closest('.header-navigation__menu-container').classList.add('menu-open');
    }
  }



  bindEvents() {
    
    document.body.addEventListener('keyup', (e) => { 
      e = e || event;
      const openMenus = Array.prototype.slice.call(document.querySelectorAll('.submenu-open, .menu-open'));
      if (!!openMenus && e.keyCode == 27) { //esc
        openMenus.forEach(item => {
          if(item.classList.contains('submenu-open')){
            item.classList.remove('submenu-open');
          }
          if(item.classList.contains('menu-open')){
            item.classList.remove('menu-open');
            item.firstChild.focus();
          }
          this.toggleAriaExpanded(item);
        });
      }
    });    


    this.menuToggler.addEventListener('click', () => {
      this.htmlTag.classList.toggle('menu-open');
    });

    this.subMenuTogglesLvl0.forEach(item => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        if(Helper.isDesktop()){
          const openMenu = document.querySelector('.menu__item--level-0.submenu-open');
          
          if(!!openMenu && openMenu != item.parentNode){
            openMenu.classList.remove('submenu-open');
            this.toggleAriaExpanded(openMenu);
          }          
        }
        item.parentNode.classList.toggle('submenu-open');
        this.toggleAriaExpanded(item.parentNode);
      });
    });

    this.subMenuTogglesLvl1.forEach(item => {
      if(Helper.isDesktop()){
        item.ariaExpanded = true; 
      } else{
        item.addEventListener('click', (e) => {
          e.preventDefault();
          item.parentNode.classList.toggle('submenu-open');
          this.toggleAriaExpanded(item.parentNode);
        });
      }
    });

    this.menuItemBack.forEach(item => {
      item.addEventListener('click', () => {
        const parent = Helper.getParentNodeWithClass(item, 'submenu-open');
        parent.classList.remove('submenu-open');
        this.toggleAriaExpanded(parent);
      });
    });

    this.menuContainerToggles.forEach(item => {
      item.addEventListener('click', () => {
        const openMenu = document.querySelector('.header-navigation__menu-container.menu-open');
        if(!!openMenu && openMenu != item.parentNode){
          openMenu.classList.remove('menu-open');
          this.toggleAriaExpanded(openMenu);
        }
        this.toggleAriaExpanded(item.parentNode);
        item.parentNode.classList.toggle('menu-open');
        
      });
    });
  }

  toggleAriaExpanded(element){
    const button = element.firstChild;
    let aria = button.getAttribute('aria-expanded');
    
    if(aria=="false"){
      aria = "true";
    } else{
      aria = "false";
    }
    button.ariaExpanded = aria;
  }

}

export default Header;
